export default [
    {
		path: '/redirect',
		name: 'Redirect',
		component: () => import('@/views/error/Redirect.vue'),
		meta: {
			layout: 'Error',
			abilities: [],
		}
	},
	{
		path: '/suspended',
		name: 'Suspended',
		component: () => import('@/views/error/Suspended.vue'),
		meta: {
			layout: 'Error',
			abilities: [['*']],
		}
	}
]